module.exports = __webpack_public_path__ + "img/unionpay.f3c55d9a.png";